import React, { lazy } from 'react';
const bonuses = [{
  title: '300 Giochi per Allenatori di Calcio Giovanile',
  desc: 'Un archivio completo di giochi per ogni obiettivo.',
  image: 'https://cdn.magicpatterns.com/uploads/ckz1BgqHgiRW8v217LwTqi/91930125-3009-4093-add4-08cf4d5f6960-mockup.webp'
}, {
  title: 'Programmazione Annuale Completa U6-U14',
  desc: 'La struttura stagionale già pronta per ogni categoria.',
  image: 'https://cdn.magicpatterns.com/uploads/iGgnJXCiq6HEbbx21bpCg1/d018aea7-cabf-43ea-9f59-db8918e20057-mockup.webp'
}, {
  title: '150 Small-Sided Games Vincenti',
  desc: 'Situazioni a campo ridotto per migliorare tecnica e tattica.',
  image: 'https://cdn.magicpatterns.com/uploads/7UVTbrLAVmgbMSxv4Mi2PL/5ae7d1b4-9778-4528-ad51-e95cf276875d-mockup.webp'
}, {
  title: "Toolkit Professionale dell'Allenatore",
  desc: 'Strumenti e schede per gestire la squadra al meglio.',
  image: 'https://cdn.magicpatterns.com/uploads/k32aEdi8u6kuFYM8GPhVCL/dc80fbab-aafb-41a1-a2e4-2d13af86be68-mockup.webp'
}, {
  title: 'Correzioni Pronte: Errori e Fix',
  desc: 'Identifica e correggi rapidamente gli errori più comuni.',
  image: 'https://cdn.magicpatterns.com/uploads/jecV4HrZM3jYQy2LABtGAi/72b2e81f-d64c-41ec-9489-9d172b03bc78-mockup.webp'
}];
export function BonusSection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-black text-white mb-4 tracking-tight" data-id="element-4">
            🎁 Ricevi anche{' '}
            <span className="text-[#16A34A]" data-id="element-5">5 Bonus Strategici</span>
          </h2>
          <p className="text-[#B0B0C0] text-lg font-medium" data-id="element-6">
            Inclusi senza costo aggiuntivo
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-7">
          {bonuses.map((bonus, i) => <div key={i} className="bg-[#16161F] border border-[#16A34A33] rounded-2xl p-5 flex flex-col" data-id="element-8">
              <div className="relative mb-4 rounded-xl overflow-hidden bg-[#0A0A0A]" data-id="element-9">
                <img src={bonus.image} alt={bonus.title} loading="lazy" className="w-full h-44 object-cover" width={512} height={512} data-id="element-10" />
              </div>
              <div className="flex items-center justify-between mb-3" data-id="element-11">
                <span className="text-[#16A34A] font-black text-sm tracking-wider uppercase" data-id="element-12">
                  Bonus 0{i + 1}
                </span>
                <span className="bg-[#00C853]/10 text-[#00C853] text-[10px] font-black px-2.5 py-1 rounded-full uppercase tracking-wider" data-id="element-13">
                  Gratuito
                </span>
              </div>
              <h4 className="text-white font-bold text-lg mb-2 leading-tight" data-id="element-14">
                {bonus.title}
              </h4>
              <p className="text-[#B0B0C0] text-sm font-medium leading-relaxed" data-id="element-15">
                {bonus.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}